import React from 'react';
import { Card, Text, Group, Stack, Button, Box, Badge } from '@mantine/core';
import { MapPin, Calendar, Home } from 'lucide-react';
import type { Project } from '../types';
interface ProjectCardProps {
  project: Project;
  onInterested?: () => void;
}
export function ProjectCard({
  project,
  onInterested
}: ProjectCardProps) {
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('en-AE', {
      style: 'currency',
      currency: 'AED',
      minimumFractionDigits: 0,
      notation: 'compact'
    }).format(amount);
  };
  return <Card shadow="sm" padding={0} radius="md" withBorder styles={{
    root: {
      borderColor: '#e2e8f0',
      overflow: 'hidden',
      transition: 'all 0.2s ease',
      '&:hover': {
        transform: 'translateY(-2px)',
        boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)',
        borderColor: '#cbd5e1'
      }
    }
  }} data-id="element-70">
      {/* Project Image */}
      <Box style={{
      height: 160,
      background: `linear-gradient(to bottom, transparent 60%, rgba(26, 35, 50, 0.8)), url(${project.image}) center/cover`,
      position: 'relative'
    }} data-id="element-71">
        <Box style={{
        position: 'absolute',
        bottom: 12,
        left: 12,
        right: 12
      }} data-id="element-72">
          <Text fw={700} size="lg" c="white" data-id="element-73">
            {project.name}
          </Text>
          <Group gap={4} data-id="element-74">
            <MapPin size={12} color="white" data-id="element-75" />
            <Text size="xs" c="white" opacity={0.9} data-id="element-76">
              {project.location}
            </Text>
          </Group>
        </Box>
      </Box>

      {/* Project Details */}
      <Stack gap="md" p="md" data-id="element-77">
        <Group justify="space-between" data-id="element-78">
          <Stack gap={2} data-id="element-79">
            <Text size="xs" c="#64748b" tt="uppercase" fw={500} data-id="element-80">
              Starting From
            </Text>
            <Text fw={700} size="lg" c="#1a2332" data-id="element-81">
              {formatCurrency(project.startingPrice)}
            </Text>
          </Stack>
          <Badge variant="light" color="green" size="lg" radius="md" leftSection={<Home size={12} data-id="element-83" />} data-id="element-82">
            {project.unitsAvailable} Units
          </Badge>
        </Group>

        <Group gap="xs" data-id="element-84">
          <Calendar size={14} color="#64748b" data-id="element-85" />
          <Text size="sm" c="#64748b" data-id="element-86">
            Completion: {project.completionDate}
          </Text>
        </Group>

        {/* Amenities */}
        <Group gap="xs" data-id="element-87">
          {project.amenities.slice(0, 3).map((amenity, index) => <Badge key={index} variant="outline" color="gray" size="sm" radius="md" data-id="element-88">
              {amenity}
            </Badge>)}
          {project.amenities.length > 3 && <Badge variant="outline" color="gray" size="sm" radius="md" data-id="element-89">
              +{project.amenities.length - 3}
            </Badge>}
        </Group>

        <Button fullWidth color="green" radius="md" size="md" onClick={onInterested} styles={{
        root: {
          backgroundColor: '#10b981',
          transition: 'all 0.2s ease',
          '&:hover': {
            backgroundColor: '#059669',
            transform: 'translateY(-1px)',
            boxShadow: '0 4px 12px rgba(16, 185, 129, 0.3)'
          }
        }
      }} data-id="element-90">
          I'm Interested
        </Button>
      </Stack>
    </Card>;
}